(function() {
  function alignHeights() {
    const gridItems = document.querySelectorAll('#product-grid .grid__item');
    if (!gridItems.length) return;

    const titleSelector = '.card-information__text';
    const subtitleSelector = '.card-information__subtitle';
    
    // Reset min-heights first
    function resetHeights(items, selector) {
      items.forEach(item => {
        const el = item.querySelector(selector);
        if (el) el.style.minHeight = '0'; // Reset to default
      });
    }

    resetHeights(gridItems, titleSelector);
    resetHeights(gridItems, subtitleSelector);

    // Group by top position with tolerance
    const rows = [];
    const threshold = 20; // 20px tolerance for row alignment

    gridItems.forEach(item => {
      // Use offsetTop for grouping
      const top = item.offsetTop;
      
      let addedToRow = false;
      for (let i = 0; i < rows.length; i++) {
        // Check if this item belongs to an existing row group (within threshold)
        if (Math.abs(rows[i].top - top) < threshold) {
          rows[i].items.push(item);
          addedToRow = true;
          break;
        }
      }

      if (!addedToRow) {
        rows.push({ top: top, items: [item] });
      }
    });

    // Apply max heights per row
    rows.forEach(row => {
      const rowItems = row.items;

      // 1. Align Titles
      let maxTitleHeight = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(titleSelector);
        if (el) {
          // Force layout calculation just in case
          maxTitleHeight = Math.max(maxTitleHeight, el.offsetHeight);
        }
      });
      
      if (maxTitleHeight > 0) {
        rowItems.forEach(item => {
          const el = item.querySelector(titleSelector);
          if (el) el.style.minHeight = maxTitleHeight + 'px';
        });
      }

      // B. Align Subtitles
      let maxSubtitleHeight = 0;
      rowItems.forEach(item => {
        const el = item.querySelector(subtitleSelector);
        if (el) {
          maxSubtitleHeight = Math.max(maxSubtitleHeight, el.offsetHeight);
        }
      });
      
      if (maxSubtitleHeight > 0) {
        rowItems.forEach(item => {
          let el = item.querySelector(subtitleSelector);
          // If element is missing OR hidden (display: none), create a placeholder
          const isHidden = el && el.offsetParent === null;
          
          if (!el || isHidden) {
             // If hidden, we don't use it. We create a placeholder.
             // Check if we already created a placeholder in a previous run? 
             // Ideally we shouldn't duplicate.
             let placeholder = item.querySelector('.product-card-alignment-placeholder');
             
             if (!placeholder) {
                 const titleFn = item.querySelector(titleSelector);
                 const wrapper = item.querySelector('.card-information__wrapper');
                 if (wrapper) {
                    placeholder = document.createElement('div');
                    placeholder.className = 'card-information__subtitle product-card-alignment-placeholder';
                    placeholder.style.visibility = 'hidden'; 
                    placeholder.innerHTML = '&nbsp;'; // Ensure it has content to respect layout
                    
                    if (titleFn && titleFn.parentNode === wrapper) {
                        titleFn.insertAdjacentElement('afterend', placeholder);
                    } else {
                        wrapper.appendChild(placeholder);
                    }
                 }
             }
             // Use the placeholder as the element to size
             el = placeholder;
          }
          
          if (el) el.style.minHeight = maxSubtitleHeight + 'px';
        });
      }
    });
  }

  // Use ResizeObserver for more robust change detection
  const gridContainer = document.getElementById('product-grid');
  if (gridContainer) {
    const observer = new ResizeObserver(entries => {
      // Simple debounce via RequestAnimationFrame
      window.requestAnimationFrame(() => {
        alignHeights();
      });
    });
    observer.observe(gridContainer);
  }

  // Fallback listeners
  window.addEventListener('load', alignHeights);
  document.addEventListener('DOMContentLoaded', alignHeights);
})();
